import { SvgImage } from '../brand/primitives';
import { getSportArtworkUrl } from './sport-artwork-web';
import type { SportArtworkProps } from './sport-artwork-types';

/** The parent supplies the SVG root; this embeds a real full-color raster resource. */
export function SportArtwork({ sport, size, onLoad }: SportArtworkProps) {
  // Stable 2x selection works during SSR and hydration without browser globals.
  const source = getSportArtworkUrl(sport, size);
  if (source === undefined) throw new Error(`Missing Lift artwork for ${sport}`);

  return (
    <SvgImage
      href={source}
      x={0}
      y={0}
      width={32}
      height={32}
      preserveAspectRatio="xMidYMid meet"
      {...(onLoad ? { onLoad } : {})}
    />
  );
}
